module.exports = __webpack_public_path__ + "assets/events_insult_white.f010d0db.svg";